import { Home } from './Home'
import { css } from 'twind/css'
import { Suspense } from 'react'
import * as Sentry from '@sentry/react'
import { useTw } from '../../../utils/Styles'
import { useWidgetOpen } from '../../../utils'
import { Routes, Route } from 'react-router-dom'
import { ErrorBoundaryContent } from './ErrorBoundaryContent'
import { StatusPageList, StatusPageDetail } from './StatusPage'
import {
  Articles,
  Categories,
  ArticleView,
  SearchArticles,
} from './KnowledgeBase'
import {
  Conversations,
  ConversationMessages,
  ConversationGuestSetup,
} from './Conversations'

const content = css`
  border: none;
  width: 360px;
  bottom: 100px;
  position: fixed;
  max-height: 600px;
  border-radius: 0.5rem;
  background: transparent;
  height: calc(100vh - 120px);
  transition: all 100ms ease-in-out;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
`

const closed_content = css`
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transform: translateY(30px);
`

const open_content = css`
  z-index: 999999999999999;
  opacity: 1;
  transform: translateY(0);
`

export function WidgetContent({ left }: { left?: boolean }) {
  const tw = useTw()
  const { open, responsive, isMobile } = useWidgetOpen()

  return (
    <div
      className={tw(
        content,
        left ? `left-[20px]` : `right-[20px]`,
        open ? open_content : closed_content,
        'bg-gray-50',
        responsive &&
          isMobile &&
          'inset-0 !w-full !h-full !max-h-full !rounded-none'
      )}
    >
      <div
        className={tw`bg-gray-50 overflow-hidden h-full w-full rounded-lg ${
          responsive && isMobile && '!rounded-none'
        }`}
      >
        <Sentry.ErrorBoundary fallback={<ErrorBoundaryContent />}>
          <Suspense fallback={<div />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/kb" element={<Categories />} />
              <Route path="/kb-search" element={<SearchArticles />} />
              <Route path="/kb/:categoryId" element={<Articles />} />
              <Route
                path="/kb/:categoryId/:articleId"
                element={<ArticleView />}
              />
              <Route path="/conversations" element={<Conversations />} />
              <Route
                path="/conversations/guest-setup"
                element={<ConversationGuestSetup />}
              />
              <Route
                path="/conversation/:id"
                element={<ConversationMessages />}
              />
              <Route path="/status-page" element={<StatusPageList />} />
              <Route
                path="/status-page/:componentId/:day"
                element={<StatusPageDetail />}
              />
              <Route
                path="/status-page/:componentId/:day/:eventId"
                element={<StatusPageDetail />}
              />
            </Routes>
          </Suspense>
        </Sentry.ErrorBoundary>
      </div>
    </div>
  )
}
